var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M13.9167 7.79183C13.9167 8.04391 13.7104 8.25016 13.4583 8.25016H2.45833C2.20499 8.25016 2 8.04535 2 7.79212C2 7.53975 2.2051 7.3335 2.45833 7.3335H13.4583C13.7104 7.3335 13.9167 7.53975 13.9167 7.79183Z","fill":"black"}})
}
var staticRenderFns = []

export { render, staticRenderFns }